import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      lotModal: {
        show: false,
        loading: false,
      },
      lot: {
        selected: [],
        product: null,
        skuId: null,
        whId: null,
        sort: {
          key: 'date_in',
          value: 'asc',
        },
        isCustomPrice: false,
      },
    }
  },

  computed: {
    ...mapState('lot', {
      lotList: 'lotList',
    }),
  },

  methods: {
    ...mapActions('lot', {
      getLotList: 'getLotList',
    }),
    async handleSortLotChange ({ key, value }) {
      this.lotModal.loading = true
      this.lot.sort.key = key
      this.lot.sort.value = value
      await this.fetchLotData()
      this.lotModal.loading = false
    },
    async fetchLotData () {
      await this.getLotList({
        page: 1,
        limit: 100000,
        'filter[sku_id]': this.lot.skuId,
        'filter[wh_id]': this.lot.whId,
        'filter[unit_balance_empty]': 'false',
        'sort[key]': this.lot.sort.key,
        'sort[value]': this.lot.sort.value,
      })
      this.showFinish(this.$Progress)
    },
    mapLots (selectedItems) {
      return selectedItems.map((lot) => {
        return {
          lotId: lot.lotId,
          lotCode: lot.lotCode,
          binId: lot.binId,
          binName: lot.binName,
          unit: Number(lot.unit),
        }
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/posSelectLot.js